import React, { useState, useRef, useEffect, useLayoutEffect } from "react"
import { Main, WLoader } from "./styles"
import { useTransform } from "framer-motion"
import { EMPTY_STRING, KILL_ROUTE } from "./../constants"
import { useWatchVariations, mvSubscribe } from "./../context"
import { rafDelay } from "./../utils"
import Price, { FixedPrice } from "components/price/Price"

function useLabel(specs_id, wactive, route, stepindex, rfmain, defaultValue = EMPTY_STRING) {
  const [label, setLabel] = useState(defaultValue)
  const _label = useTransform([wactive, stepindex], update)

  function update([wactive, stepindex]) {
    const sid = specs_id < 0 ? (stepindex < 1 ? defaultValue : stepindex + 2) : specs_id
    //    console.log("wactive", wactive)
    return wactive?.specs[sid] || defaultValue
  }

  function render() {
    setLabel(_label.get())
    //    console.log("useLabel onWactive render", specs_id)
  }
  /*
  function display() {
    cssSwap(rfmain.current, "wv_reveal", render)
  }
*/
  useEffect(() => mvSubscribe("FooterTitle _label", _label, render, false), [])
  /*
  function onRoute(v) {
    if (!v) kill()
    else render()
  }

  function kill() {
    setLabel(null)
  }
*/
  //  useEffect(() => mvSubscribe("Footer useLabel route", route, onRoute, false), [])

  return label
}

function FooterTitle({ ctx, wactive, id }) {
  const { route, stepindex } = useWatchVariations(ctx)
  const rfmain = useRef()
  const label = useLabel(3, wactive, route, stepindex, rfmain)

  return <h2 ref={rfmain} id={id}>{label}</h2>
}

function FooterFull({ ctx, wactive }) {
  const { route, stepindex } = useWatchVariations(ctx)
  const rfmain = useRef()
  const label = useLabel(0, wactive, route, stepindex, rfmain)

  return <p ref={rfmain} dangerouslySetInnerHTML={{ __html: label }}></p>
}

function FooterDetail({ ctx, wactive }) {
  const { route, stepindex } = useWatchVariations(ctx)
  const rfmain = useRef()
  const rfload = useRef()
  const label = useLabel(-1, wactive, route, stepindex, rfmain)

  function onGready(v) {
    display(!!v)
  }

  function onRoute(v) {
    if (!v || v === KILL_ROUTE) display(false)
  }

  function onLabel(v) {
    display(!!v)
  }

  function onNewstepindex(v) {
    display(false)
  }

  function display(v) {
    rfmain.current?.classList[v ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("Footer route", route, onRoute), [])
  useLayoutEffect(() => {
    display(!!label)
  }, [label])

  return (
    <>
      <p ref={rfmain} dangerouslySetInnerHTML={{ __html: label }}></p>
    </>
  )
}

export function FooterPrice({ active, updateModel, ariaDescribedBy }) {
  const [rmc, setRmc] = useState(null)
  const rfmain = useRef()

  function update(v) {
    if (!v) return
    rfmain.current?.classList.remove("wv_reveal")
    setRmc(null)
    rafDelay(() => setRmc(v))
  }

  function onPriceReady(v, data) {
    updateModel(v, data)
    rfmain.current?.classList[v === rmc ? "add" : "remove"]("wv_reveal")
  }
  useEffect(() => mvSubscribe("FooterTitle active", active, update), [])

  return <div ref={rfmain}>{rmc ? <Price rmc={rmc} onReady={onPriceReady} no_observer={true} ariaDescribedBy={ariaDescribedBy} /> : null}</div>
}

function FooterPriceFromList({ active, pricelist, ariaDescribedBy }) {
  //  console.log("pricelist", pricelist)
  const [rmc, setRmc] = useState(null)
  const rfmain = useRef()

  function update(v) {
    if (!v) return
    rfmain.current?.classList.remove("wv_reveal")
    setRmc(null)
    rafDelay(() => {
      setRmc(v)
      rfmain.current?.classList.add("wv_reveal")
    })
  }
  useEffect(() => mvSubscribe("FooterTitle active", active, update), [])

  return <div ref={rfmain} className="wv_reveal">{rmc ? <FixedPrice rmc={rmc} formattedPrice={pricelist.get(rmc)} pricePopin={pricelist.get("pricePopin")} ariaDescribedBy={ariaDescribedBy} /> : null}</div>
}

export function Footer({ ctx, is_entry = false, id }) {
  const { route, active, entry, wactive, wentry, updateModel } = useWatchVariations(ctx)
  const rfmain = useRef(null)

  function onRoute(v) {
    display(!!v && v !== KILL_ROUTE)
  }

  function onWactive(v) {
    //    console.log("Footer onWactive", v)
    if (!v || !route.get()) return
    display(true)
  }

  function display(v) {
    rfmain.current?.classList[!!v ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])
  useLayoutEffect(() => mvSubscribe("FooterTitle wactive", wactive, onWactive, false), [])
  //  useLayoutEffect(() => mvSubscribe("VarNav route", gready, onGready), [])

  return (
    <Main ref={rfmain} aria-live='polite'>
      <FooterTitle ctx={ctx} wactive={is_entry ? wentry : wactive} id={id} />
      <FooterDetail ctx={ctx} wactive={is_entry ? wentry : wactive} />
      <FooterFull ctx={ctx} wactive={is_entry ? wentry : wactive} />
      <FooterPrice active={is_entry ? entry : active} updateModel={updateModel} ariaDescribedBy={id} />
    </Main>
  )
}

export function FooterInCard({ ctx, pid }) {
  const { route, active, entry, wactive, pricelist, updateModel } = useWatchVariations(ctx)
  const rfmain = useRef(null)

  function onRoute(v) {
    display(!!v && v !== KILL_ROUTE)
  }

  function onWactive(v) {
    //    console.log("Footer onWactive", v)
    if (!v || !route.get()) return
    display(true)
  }

  function display(v) {
    rfmain.current?.classList[!!v ? "add" : "remove"]("wv_reveal")
  }

  useLayoutEffect(() => mvSubscribe("VarNav route", route, onRoute), [])
  useLayoutEffect(() => mvSubscribe("FooterTitle wactive", wactive, onWactive, false), [])
  //  useLayoutEffect(() => mvSubscribe("VarNav route", gready, onGready), [])

  return (
    <Main ref={rfmain} aria-live='polite'>
      <FooterDetail ctx={ctx} wactive={wactive} />
      <FooterPriceFromList active={active} pricelist={pricelist} updateModel={updateModel} ariaDescribedBy={pid} />
    </Main>
  )
}
